import React from "react";
import ItemSpacer from "../ItemSpacer";

const InfoItemIconList = (props: { children: React.ReactNode }) => {
  return <ItemSpacer gap={20}>{props.children}</ItemSpacer>;
};

export default InfoItemIconList;
